<!--
 * @Author: DXG
 * @Date: 2024-04-16 14:05:39
 * @LastEditors: situgen@szkingdom.com
 * @LastEditTime: 2026-01-27 18:51:31
 * @FilePath: \kdtup-pc-web\src\bizcomponents\fund\dividendInfo.vue
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
-->
<!--
Author: jiangli
Date: 2021-03-19
Desc: 分红信息明细
 -->
<template>
    <div>
        <div :class="'bizcomp-trade-record bizcomp ' + className">
            <el-tabs v-model="curActive">
                <el-tab-pane label="我的分红" name="first">
                    <div class="trade-record">
                        <!-- 查询条件start -->
                        <el-row class="fund-filter">
                            <el-col :span="24" class="btn-fund">
                                分红发放日：
                                <el-radio-group v-model="tradeTime" size="mini">
                                    <el-radio-button
                                        v-for="type in tradeTimeArr"
                                        :key="type.val"
                                        :label="type.val"
                                    >
                                        {{ type.text }}
                                    </el-radio-button>
                                </el-radio-group>
                                <div v-if="tradeTime === '6'" class="custom-time">
                                    <span class="auto-define">
                                        &nbsp;&nbsp;&nbsp;&nbsp;自定义：
                                    </span>
                                    <el-date-picker
                                        v-model="beginDate"
                                        value-format="yyyyMMdd"
                                        type="date"
                                        placeholder="开始日期"
                                        style="width: 150px"
                                        :picker-options="startDatePicker"
                                    ></el-date-picker>
                                    <span style="margin: 0 5px">-</span>
                                    <el-date-picker
                                        v-model="endDate"
                                        value-format="yyyyMMdd"
                                        type="date"
                                        placeholder="结束日期"
                                        style="width: 150px"
                                        :picker-options="endDatePicker"
                                    ></el-date-picker>
                                    <el-button
                                        type="danger"
                                        size="small"
                                        style="margin-left: 10px"
                                        v-on:click="searchFund"
                                    >
                                        查询
                                    </el-button>
                                </div>
                            </el-col>
                            <el-col :span="24" class="btn-search">
                                基金名称：
                                <el-autocomplete
                                    v-model="searchText"
                                    popper-class="my-autocomplete"
                                    placeholder="请输入查询基金名称或基金代码"
                                    class="input-search"
                                    size="small"
                                    style="width: 350px"
                                    :fetch-suggestions="querySearchAsync"
                                    v-on:select="queryFundName"
                                >
                                    <template slot-scope="{ item }">
                                        <div class="name">
                                            {{ item.value }}
                                        </div>
                                    </template>
                                </el-autocomplete>
                                <!-- <el-button class="btn-search-icon" icon="el-icon-search" type="primary" size="small"
                                    v-on:click="searchFund" /> -->
                            </el-col>
                        </el-row>
                        <!-- 查询条件end -->

                        <!-- 表格start -->
                        <el-table :data="fund" style="width: 100%" class="tab-list-tit">
                            <el-table-column
                                prop="registrationdate"
                                label="分红发放日"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <span>
                                        {{ $util.fmtDate(scope.row.dividentdate) || "--" }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="registrationdate"
                                label="权益登记日"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <span>
                                        {{ $util.fmtDate(scope.row.registrationdate) || "--" }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="fundname"
                                label="基金名称"
                                align="center"
                                width="130"
                            >
                                <template slot-scope="scope">
                                    <div>
                                        <p>{{ scope.row.fundname }}</p>
                                        <p>{{ scope.row.fundcode }}</p>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="basisforcalculatingdividend"
                                label="份额基数"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <span>
                                        {{ scope.row.basisforcalculatingdividend || "/" }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                width="130"
                                prop="dividendperunit"
                                label="每十份分红金额"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <span>
                                        {{
                                            scope.row.defdividendmethod == "1"
                                                ? scope.row.dividendperunit
                                                : "/"
                                        }}
                                    </span>
                                </template>
                            </el-table-column>

                            <el-table-column
                                prop="confirmedamount"
                                label="现金红利"
                                align="center"
                            />
                            <el-table-column
                                prop="confirmedvol"
                                label="红利再投份额"
                                align="center"
                            />
                            <el-table-column prop="nav" label="再投净值" align="center">
                                <template slot-scope="scope">
                                    <span>
                                        {{
                                            scope.row.defdividendmethod == "0"
                                                ? $util.fmtNum(scope.row.nav, 4)
                                                : "/"
                                        }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="depositcard" label="关联账号" align="center">
                                <template slot-scope="scope">
                                    <span>
                                        {{ scope.row.depositcard || "/" }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="distributorname" label="销售机构" align="center">
                                <template slot-scope="scope">
                                    <span>
                                        {{ scope.row.distributorname || "/" }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="showOtherfee2" prop="otherfee2" align="center">
                                <template slot="header">
                                    <span>返还销售服务费</span>
                                    <el-tooltip
                                        effect="dark"
                                        content="货币基金的返还销售服务费通过红利再投资，以份额的形式返还。"
                                        placement="top-start"
                                    >
                                        <i
                                            class="el-icon-info"
                                            style="
                                                margin-left: 5px;
                                                color: var(--color-text-accent);
                                            "
                                        ></i>
                                    </el-tooltip>
                                </template>
                                <template slot-scope="scope">
                                    <span style="color: var(--color-primary)">
                                        {{ $util.fmtNum(scope.row.otherfee2) }}元
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="defdividendmethod"
                                label="分红方式"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <span class="c_E60012">
                                        {{
                                            $cache.getDict(
                                                "90273",
                                                scope.row.defdividendmethoddetail
                                            )
                                        }}
                                    </span>
                                </template>
                            </el-table-column>

                            <!-- <el-table-column prop="taserialno" label="TA确认流水号" align="center" />



                            <el-table-column prop="taserialno" label="TA确认流水号" align="center" />
                            <el-table-column prop="transactioncfmdate" label="分红确认日期" align="center"
                                :formatter="formatterDate" />
                            <el-table-column prop="fundname" label="基金名称" align="center" :formatter="formatterName">
                                <template slot-scope="scope">
                                    <span class="like-a" v-on:click.prevent="gotoDetail(scope.row)">{{
        scope.row.fundname }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="confirmedvol" label="确认份额" align="center"
                                :formatter="formatterCfmAmount">
                            </el-table-column>
                            <el-table-column prop="confirmedamount" label="确认金额" align="center"
                                :formatter="formatterCfmAmount">
                            </el-table-column>
                            <el-table-column label="详情" align="center">
                                <template slot-scope="scope">
                                    <span class="like-a"
                                        v-on:click.prevent="fundDetail = scope.row; detailVisible = true">详情</span>
                                </template>
                            </el-table-column> -->
                        </el-table>
                        <!-- 表格end -->

                        <!-- 分页start -->
                        <el-row v-if="allPage > 0" class="page-box">
                            <el-pagination
                                :page-size="Number(conf.PAGE_SIZE)"
                                :current-page.sync="curPage"
                                layout="->, total, prev, pager, next"
                                :total="Number(allPage)"
                                v-on:current-change="pageRefresh"
                            />
                        </el-row>
                        <!-- 分页end -->
                    </div>
                </el-tab-pane>
                <el-tab-pane
                    v-if="$util.getConfig().hideFunc && !$util.isWebQueryMode()"
                    label="修改分红方式"
                    name="second"
                >
                    <div v-if="isOpenAccount" class="trade-record">
                        <upd-bonus-list v-show="curActive === 'second'"></upd-bonus-list>
                    </div>
                </el-tab-pane>
            </el-tabs>

            <!--详情弹框start -->
            <!-- <el-dialog title="详细信息" :visible.sync="detailVisible" class="prop info-tips" width="1000px">
            <div class="investor-tips">
                <div class="prompt-info">
                    <el-form label-position="left" inline class="demo-table-expand" style="max-height: 220px;">
                        <el-form-item label="TA确认流水号">
                            <span>{{ fundDetail.taserialno ? fundDetail.taserialno : '--' }}</span>
                        </el-form-item>
                        <el-form-item label="分红确认日期">
                            <span>
                                {{
                                fundDetail.transactioncfmdate ? $util.fmtDate(fundDetail.transactioncfmdate) : '--'
                                }}
                            </span>
                        </el-form-item>
                        <el-form-item label="基金名称">
                            <span>
                                {{ fundDetail.fundname ? fundDetail.fundname : '--' }}
                            </span>
                        </el-form-item>
                        <el-form-item label="确认份额">
                            <span>
                                {{ $util.fmtNum(fundDetail.confirmedvol) }}
                            </span>
                        </el-form-item>
                        <el-form-item label="确认金额">
                            <span>
                                {{ $util.fmtNum(fundDetail.confirmedamount) }}
                            </span>
                        </el-form-item>
                        <el-form-item label="基金账号">
                            <span>
                                {{ fundDetail.taaccountid ? fundDetail.taaccountid : '--' }}
                            </span>
                        </el-form-item>
                        <el-form-item label="业务类型">
                            <span>{{ fundDetail.businesscode?$cache.getDict('130010', fundDetail.businesscode) : '--'
                                }}</span>
                        </el-form-item>
                        <el-form-item label="份额净值">
                            <span>{{ $util.fmtNum(fundDetail.nav, 4) }}</span>
                        </el-form-item>
                        <el-form-item label="确认信息">
                            <span>
                                {{ fundDetail.returnmsg ? fundDetail.returnmsg : '--' }}
                            </span>
                        </el-form-item>
                        <el-form-item label="分红方式">
                            <span>{{
                                fundDetail.dividendmethod ? $cache.getDict('110001', fundDetail.dividendmethod) : '--'
                                }}</span>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </el-dialog> -->
            <!--详情弹框end -->
        </div>
        <footerQuestions
            v-if="$const.warmReminderDisplay"
            :common-question="commonQuestion"
            :warning-html="warningHtml"
        ></footerQuestions>
    </div>
</template>
<script>
import format from "date-fns/format";
import mixin from "@/assets/js/mixin";
import updBonusList from "@/bizcomponents/fund/updBonusList.vue";
import fundApi from "@/api/fund";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import warningHtml from "@/constant/warning_html.js";

export default {
    name: "DividendInfo",
    components: {
        updBonusList,
        footerQuestions
    },
    mixins: [mixin],
    data() {
        return {
            isOpenAccount: this.$cache.getBinded(),
            curSelectDate: [],
            curActive: "first",
            curPage: 1,
            tradeTime: "", // 已选择的时间周期
            searchText: "", // 基金名称或基金代码
            fund: [], // 表格数据
            endDate: "", // 结束时间
            beginDate: "", // 开始时间
            nowDate: "", // 当前时间
            pagecount: "", // 页码大小
            pageoffset: "1",
            allPage: "0", // 分页总数量
            queryFind: null, // 限制前后两次请求间隔时间的定时器
            timer: null,
            queryFund: {},
            queryFundList: [], // 输入框匹配列表
            query: null, // 限制规定时间内请求次数的定时器
            index: 0, // 连续点击次数
            tradeTimeArr: [
                // 时间周期
                { val: "1", text: "近7天" },
                { val: "2", text: "近一个月" },
                { val: "3", text: "近三个月" },
                { val: "4", text: "近半年" },
                { val: "5", text: "近一年" },
                { val: "6", text: "自定义" }
            ],
            fundDetail: {}, // 详情弹框数据
            detailVisible: false, // 是否展示详情弹框
            dateSet: { type: "2", min: "1990-01-01", size: "mini" }, // 时间选择器组件属性
            warningHtml: "",
            commonQuestion: []
        };
    },

    computed: {
        startDatePicker() {
            return {
                disabledDate: (time) => {
                    if (this.endDate) {
                        const y = this.endDate.substring(0, 4);
                        const m = this.endDate.substring(4, 6);
                        const d = this.endDate.substring(6, 8);
                        const endDateObj = new Date(y, m - 1, d);
                        return time.getTime() > endDateObj.getTime();
                    }
                    return false;
                }
            };
        },
        endDatePicker() {
            return {
                disabledDate: (time) => {
                    if (this.beginDate) {
                        const y = this.beginDate.substring(0, 4);
                        const m = this.beginDate.substring(4, 6);
                        const d = this.beginDate.substring(6, 8);
                        const beginDateObj = new Date(y, m - 1, d);
                        return time.getTime() < beginDateObj.getTime();
                    }
                    return false;
                }
            };
        },
        showOtherfee2() {
            const oemList = this.$cache.getCompanyInfoParam("88202302") || "";
            return oemList.indexOf("AC9") > -1;
        }
    },
    watch: {
        curActive(val, old) {
            if (val === "second" && !this.isOpenAccount) {
                this.$nextTick(() => {
                    this.curActive = "first";
                    this.$belongToDialog();
                });
            }
        },
        searchText(val, from) {
            if (val == "") {
                this.queryFund = { id: "" };
                this.pageoffset = "1";
                this.doAction();
            }
        },
        // 已选择的时间周期
        tradeTime(val, old) {
            this.curPage = 1;
            this.pageoffset = "1";
            this.fund = [];
            this.allPage = 0;
            this.endDate = this.nowDate;
            const _x = new Date(this.$util.fmtDate(this.nowDate)).getTime();
            if (val === "1") {
                this.beginDate = format(_x - 7 * 24 * 3600 * 1000, "YYYYMMDD");
            } else if (val === "2") {
                this.beginDate = this.$util.getBeginDate(this.nowDate, 1);
            } else if (val === "3") {
                this.beginDate = this.$util.getBeginDate(this.nowDate, 3);
            } else if (val === "4") {
                this.beginDate = this.$util.getBeginDate(this.nowDate, 6);
            } else if (val === "5") {
                this.beginDate = this.$util.getBeginDate(this.nowDate, 1, true);
            } else if (val === "6") {
                this.fund = [];
                this.allPage = 0;
                this.endDate = "";
                this.beginDate = "";
                return;
            }
            this.pageoffset = "1";
            this.doAction();
        }
        // curActive(val,old) {
        //     if (val=== 'first') {

        //     }
        // }
    },

    created() {
        this.warningHtml = warningHtml.warningHtml5;
        this.conf = this.$util.getConfig().const;
        this.commonQuestion = this.$const.commonQuestion.commonQuestion5;
        this.nowDate = format(new Date(), "YYYYMMDD");
        // 初始化页码
        this.pagecount = this.$util.getConfig().const.PAGE_SIZE;
        this.dateSet.max = this.$util.fmtDate(this.nowDate);
        this.tradeTime = "1";
    },

    methods: {
        // 跳转路由到基金详情
        gotoDetail(val) {
            let params = {
                secondtype: val.fundcode,
                etfflag: val.etfflag
            };
            if (val.fundtype === "4") {
                params["watchcontrol"] = "1"; // 专户可查公告
            }
            this.$util.toCompPage("/fund", params);
        },

        // 格式化日期
        formatterDate(row, column, value) {
            return this.$util.fmtDate(value);
        },

        // 格式化基金名称
        formatterName(row, column, value) {
            if (
                row.businesscode === "36" ||
                row.businesscode === "D2" ||
                row.businesscode === "69" ||
                (row.businesscode === "24" &&
                    (row.businesskind === "2" || row.businesskind === "6"))
            ) {
                return row.targetfundname + "(" + row.targetfundcode + ")";
            }
            return row.fundname + "(" + row.fundcode + ")";
        },

        // 格式化金额
        formatterCfmAmount(row, column, value) {
            return this.$util.fmtNum(value);
        },

        // 指定每行row-key
        getRowKeys(row) {
            return row.appsheetserialno;
        },

        // 获取用户选中时间区间
        dateInterval(val) {
            // convert "YYYY-MM-DD" to "YYYYMMDD"
            this.beginDate = this.$util.isEmpty(val.beginDate)
                ? ""
                : val.beginDate.replace(/-/g, "");
            this.endDate = this.$util.isEmpty(val.endDate) ? "" : val.endDate.replace(/-/g, "");
        },

        // 改变分页
        pageRefresh(val) {
            this.pageoffset = val;
            this.doAction();
        },

        // 搜索基金
        searchFund() {
            this.curPage = 1;
            this.pageoffset = "1";
            this.doAction();
        },

        // 获取基金信息
        async getFund(val, cb) {
            const _x = {
                producttype: "*",
                begindate: this.beginDate,
                enddate: this.endDate,
                // sourceflag: this.fundFrom,
                fundcode: this.queryFund.id || "",
                pageSize: this.pagecount,
                pageNum: this.pageoffset.toString()
                // businesscode: "143", //分红信息查询
                // appflag: "0" //在途标识0-全部 1-在途，2查询未支付申请
            };
            const res = await fundApi.qryDividendInfo(_x);
            this.fund = res.data.data;
            this.fund.forEach((item) => {
                if (item.defdividendmethod == "0") {
                    // 红利再投资
                    item.defdividendmethoddetail = "3";
                } else {
                    if (item.businesskind == "C1") {
                        // 自动充值至钱柜
                        item.defdividendmethoddetail = "1";
                    } else {
                        // 发放至银行卡
                        item.defdividendmethoddetail = "2";
                    }
                }
            });
            this.allPage = res.data.total;
        },

        // 筛选列表数据
        filterSame(data) {
            if (data.length === 0) {
                return [];
            }
            let records = [data[0]];
            let skip = "confirmedvol"; // 原4.0 cfmevol 确认份额，120,130两笔记录返回数据只有这个字段不同
            data.forEach((rs) => {
                // 认购记录有两比记录120认购申请确认、认购结果确认，有认购结果只显示认购结果一条
                let isSame = true;
                records.forEach((rs1) => {
                    isSame = true;
                    for (let key in rs) {
                        if (key === skip) continue;
                        if (rs[key] !== rs1[key]) {
                            isSame = false;
                            break;
                        }
                    }
                });
                if (!isSame) {
                    records.push(rs);
                } else {
                    this.allPage -= 1;
                }
            });
            return records;
        },

        // 连续请求次数限制
        actionLimit() {
            const _this = this;
            if (this.query !== null) {
                clearTimeout(this.query);
                this.index++;
            }
            this.query = setTimeout(() => {
                _this.index = 0;
                clearTimeout(this.query);
            }, 2000);
            if (this.index > 3) {
                this.$alert("您请求太频繁，请等待一会！", "访问提示");
                this.query = setTimeout(() => {
                    _this.index = 0;
                    clearTimeout(this.query);
                }, 500);
            }
            return true;
        },

        // 对基金频繁查询请求做处理
        doAction() {
            // 连续请求次数限制
            // this.actionLimit();
            this.fund = [];
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(() => {
                this.getFund();
            }, 100);
        },
        // 获取下拉列表数据
        querySearchAsync(queryString, cb) {
            clearTimeout(this.timer);
            this.timer = setTimeout(async () => {
                const res = await fundApi.getFundLists({
                    tradingmethod: this.$util.getConfig().systemtype,
                    fundclass: "*",
                    smprodtype: "",
                    keyword: this.$util.filterCode(queryString),
                    pagesize: "40",
                    pagenum: "1"
                });
                let _cbArr = [];
                res.data.list.forEach((item, index) => {
                    let _x = {};
                    _x.value = item.fundname + "(" + item.fundcode + ")";
                    _x.id = item.fundcode;
                    _x.index = index;
                    _cbArr.push(_x);
                });
                this.queryFundList = _cbArr;
                cb(_cbArr);
            }, 500);
        },
        // 选中建议项
        handleSelect(item) {
            this.queryFund = item;
        },
        queryBlur() {
            setTimeout(() => {
                if (!this.queryFundList.some((item) => item.value === this.searchText)) {
                    this.queryFund = { id: "" };
                    this.searchText = "";
                }
            }, 100);
        },
        // 监听日期选择器
        getDate(val) {
            if (val.length === 2) {
                this.beginDate = val[0];
                this.endDate = val[1];
                this.getFund();
            }
        },
        queryFundName(val) {
            // console.log(val);
            // this.fundcode = val.id
            this.curPage = 1;
            this.pageoffset = "1";
            this.fund = [];
            this.allPage = 0;
            this.queryFund.id = val.id;
            this.getFund();
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-trade-record {
    ::v-deep .el-tabs__item {
        color: var(--color-text-regular);
        font-size: 20px;
    }
    ::v-deep .el-tabs__item.is-top.is-active {
        color: $bg18;
    }
    padding: 24px 0;
    /*自定义时间控件*/
    .custom-time {
        display: block !important;
        margin-top: 20px;
        vertical-align: middle;
        .auto-define {
            text-align: right;
        }

        .comp-date-picker {
            width: auto;
        }

        .el-button {
            min-width: 100px;
            border-color: $color-b;
            color: $color-b;
            background-color: $bg5;
            padding: 8px 15px;
            margin-left: 13px;
        }
    }

    .info-tips {
        .two-cols-form .el-form-item__content {
            .el-input {
                width: 70%;
            }
        }

        .prompt-info {
            .el-icon-warning {
                color: var(--color-primary);
                margin-right: 8px;
                font-size: $f24;
                vertical-align: middle;
            }

            span {
                vertical-align: middle;
            }
        }
    }
}
.trade-record {
    min-height: 80vh;
}
:deep(.el-tabs__header) {
    border-bottom: 1px solid var(--color-border-base);
    .el-tabs__nav {
        margin-left: 20px;
        position: relative;
        height: 52px;
    }
    .el-tabs__active-bar {
        height: 4px;
        position: absolute;
        top: 42px;
    }
    .el-tabs__nav-wrap::after {
        height: 0;
    }
}

::v-deep .tab-list-tit.el-table th {
    background: var(--color-bg-page);
}
.el-table {
    border-left: 1px solid var(--color-border-base);
    border-right: 1px solid var(--color-border-base);
    border-bottom: 1px solid var(--color-border-base);
    &::before {
        display: none;
    }
}
.page-box {
    padding: 0;
}
.el-pagination {
    margin-bottom: 0;
}
</style>
